import { executeRequest, Request } from '@jfs/network'
import { CampaignGraphParser } from '../network/parsers/CampaignGraphParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return CampaignGraphParser(respData)
}

const getCampaignGraphData = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.getCampaignGraphData}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getCampaignGraphData }
